import { render } from "./Show2.vue?vue&type=template&id=5e1797fd"
import script from "./Show2.vue?vue&type=script&lang=js"
export * from "./Show2.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__